import { TENANT_BE, TENANT_CH } from 'shared/consts/tenants'

export const ML_TENANTS = [TENANT_CH, TENANT_BE]
